export const bodyTextStyle = {
  fontSize: 14,
  lineHeight: "20px",
  fontWeight: 400,
  color: "var(--sl-text-quaternary)",
};

export const truncatedBodyTextStyle = {
  ...bodyTextStyle,
  maxWidth: 200,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};
